<template>
  <div class="previewContainer">
    <div class="background-img" id="backgroundImg" v-if="showType === 2">
      <svg class="icon" id="audioIcon" aria-hidden="true">
        <use xlink:href="#icon-others-audio"></use>
      </svg>
    </div>
    <el-row type="flex" align="middle" justify="middle" class="preview-empty">
      <el-col class="app-preview" :span="24">
        <video-preview v-if="showType === 1" :from-pc-preview="1" :id="parseInt(id)"
                       :preview-url="previewUrl"></video-preview>
        <Audio-view :from-app="true" ref="audioViewer"
                    @error="errorAudioInfo" v-if="showType === 2"></Audio-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VideoPreview from "./VideoPreview"
import AudioView from "./AudioPreview"

let vm
export default {
  beforeCreate() {
    vm = this
  },
  data() {
    return {
      id: this.$route.query.fileId,
      authorization: this.$route.query.authorization,
      showType: 0, // 音视频类别(0.都不展示 1.视频 2.音频)
      previewUrl: ''
    }
  },
  components: {
    VideoPreview,
    AudioView
  },
  mounted() {
    //设置登录信息
    if (vm.authorization && typeof vm.authorization != 'undefined') {
      localStorage.setItem('rs_t', vm.authorization)
    }
    vm.checkPreviewFile()
  },
  methods: {
    checkPreviewFile() {
      vm.ucloading.showLoading()
      this.$api.get("/resapi/app/resource-file/checkPreviewFile", {
        params: {
          id: vm.id
        }
      }).then(res => {
        vm.ucloading.hideLoading()
        if (!res.success) {
          return vm.$message.error(res.info)
        }
        vm.previewUrl = res.data.previewUrl || ''
        if(res.data.fileType !== null && res.data.fileType !== undefined) {
          if(res.data.fileType >= 91 && res.data.fileType <= 120) {
            vm.showType = 1
          }else if(res.data.fileType >= 61 && res.data.fileType <= 90) {
            vm.showType = 2
            vm.$nextTick(() => {
              const clientWidth = document.documentElement.clientWidth
              document.getElementById('audioIcon').style.fontSize = (clientWidth * 0.25) + 'px'
              document.getElementById('backgroundImg').style.top = 'calc(50% - ' + ((clientWidth * 0.25) * 0.5 + 50) + 'px)'
              vm.$refs.audioViewer.playMusic(vm.id, '', vm.previewUrl)
            })
          }
        }
      }).catch(res => {
        vm.ucloading.hideLoading()
        console.log(res)
      })
    },
    errorAudioInfo(msg){
      vm.$message.error(msg)
    }
  }
}
</script>

<style lang="scss">
.previewContainer {
  height: 100%;
  width: 100%;

  .background-img {
    width: 100%;
    text-align: center;
    position: absolute;
  }
}

.app-preview {
  .xgplayer-skin-default.xgplayer-music .xgplayer-controls .xgplayer-progress {
    top: 50%;
  }

  .xgplayer-skin-default.xgplayer-music .xgplayer-controls .xgplayer-time {
    top: calc(50% - 8px);
  }
}
</style>
